import { firstValueFrom, from } from 'rxjs';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  DELETE_SUCCESS,
  SAVE_SUCCESS,
  SYS_ERROR,
  UPDATE_SUCCESS,
} from '../../../shared/common/message/MessageCommon';
import { User } from '../../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  currentUser: any;
  userPath: string = 'users';
  constructor(private db: AngularFirestore, private message: NzMessageService) {
    this.currentUser = localStorage.getItem('currentUser')?JSON.parse(localStorage.getItem('currentUser') || ''):null;
  }

  async getAllUser() {
    let collection = this.db.collection<User>(this.userPath).get();

    const newsDataDB = await firstValueFrom(collection);
    let newsData: any[] = newsDataDB.docs.map((doc) => doc.data()) || [];
    return [...newsData];
  }

  getUserById(id: string) {
    return this.db.collection<User>(this.userPath, (ref) =>
      ref.where('id', '==', id)
    );
  }

  async getUserByEmail(email: string) {
    let collection = this.db.collection<User>(this.userPath, (ref) =>
    ref.where('email', '==', email)).get();

    const newsDataDB = await firstValueFrom(collection);
    let newsData: any[] = newsDataDB.docs.map((doc) => doc.data()) || [];
    return {id : newsData[0]?.id, login_error_count: newsData[0]?.login_error_count?newsData[0]?.login_error_count:0} || null;
  }
  
  add(data: any): void {
    this.db
      .collection<User>(this.userPath)
      .doc(data.id)
      .set({ ...data })
      .then(() => {
        this.message.success(SAVE_SUCCESS);
      })
      .catch((err) => {
        this.message.error(SYS_ERROR);
      });
  }

  edit(data: any): void {
    this.db
      .collection<User>(this.userPath)
      .doc(data.id)
      .set({ ...data })
      .then(() => {
        this.message.success(UPDATE_SUCCESS);
      })
      .catch((err) => {
        this.message.error(SYS_ERROR);
      });
  }

  delete(data: any) {
    return from (
    this.db
      .collection<User>(this.userPath)
      .doc(data.id)
      .set({ ...data })
      .then(() => {})
      .catch((err) => {
        this.message.error(SYS_ERROR);
      })
    )
  }

  regeneratedPassword(data: any, newPassword: string): void {
    const user: User = {
      ...data,
      isChangePassword: true,
      password: newPassword,
      updated_by_user: this.db.doc('users/' + this.currentUser.user_id).ref,
      updated_date: new Date(),
    };

    this.db
      .collection<User>(this.userPath)
      .doc(data.id)
      .set({ ...user })
      .then(() => {
        this.message.success(SAVE_SUCCESS);
      })
      .catch((err) => {
        this.message.error(SYS_ERROR);
      });
  }

  generatePassword(length = 16) {
    const charset =
      'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let retVal = '';
    for (let i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  updateLoginErrorCount(userId : string, countError: number) {
    return from(
      this.db
      .collection<User>('users')
      .doc(userId).update({login_error_count : countError})
    )
  }
}
